import clsx from 'clsx'
import { KTSVG } from '../../../helpers'
import { useThemeMode, systemMode } from './ThemeModeProvider'

type Props = {
  toggleBtnClass?: string
  toggleBtnIconClass?: string
}

const ThemeModeSwitcher = ({
  toggleBtnClass = '',
  toggleBtnIconClass = 'svg-icon-2',
}: Props) => {
  const { mode, updateMode, updateMenuMode } = useThemeMode()
  const calculatedMode = mode === 'system' ? systemMode : mode
  const isDark = calculatedMode === 'dark'

  const setTheme = (nextMode: 'light' | 'dark') => {
    if (nextMode === calculatedMode) return
    updateMenuMode(nextMode)
    updateMode(nextMode)
  }

  const toggleTheme = () => setTheme(isDark ? 'light' : 'dark')

  return (
    <div
      className={clsx(
        'ss-theme-mode-toggle',
        isDark ? 'ss-theme-mode-toggle--dark' : 'ss-theme-mode-toggle--light',
        toggleBtnClass
      )}
      role='group'
      aria-label='Theme mode'
    >
      <button
        type='button'
        className={clsx('ss-theme-mode-toggle__icon-btn ss-theme-mode-toggle__icon-btn--sun', {
          'ss-theme-mode-toggle__icon-btn--active': !isDark,
        })}
        onClick={() => setTheme('light')}
        aria-pressed={!isDark}
        aria-label='Light mode'
        title='Light mode'
      >
        <KTSVG
          path='/media/icons/duotune/general/gen060.svg'
          className={clsx('ss-theme-mode-toggle__icon', toggleBtnIconClass)}
        />
      </button>

      <button
        type='button'
        className={clsx('ss-theme-mode-toggle__switch', {
          'ss-theme-mode-toggle__switch--dark': isDark,
        })}
        onClick={toggleTheme}
        role='switch'
        aria-checked={isDark}
        aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      >
        <span className='ss-theme-mode-toggle__knob' aria-hidden='true' />
      </button>

      <button
        type='button'
        className={clsx('ss-theme-mode-toggle__icon-btn ss-theme-mode-toggle__icon-btn--moon', {
          'ss-theme-mode-toggle__icon-btn--active': isDark,
        })}
        onClick={() => setTheme('dark')}
        aria-pressed={isDark}
        aria-label='Dark mode'
        title='Dark mode'
      >
        <KTSVG
          path='/media/icons/duotune/general/gen061.svg'
          className={clsx('ss-theme-mode-toggle__icon', toggleBtnIconClass)}
        />
      </button>
    </div>
  )
}

export { ThemeModeSwitcher }
